import buildingImg from "../images/bg.jpg"
import windoors from "../images/Windoors.jpeg"
import doors from "../images/Doors.jpeg"
import partation from "../images/partition.jpeg"
import elevation from "../images/Elevation.jpeg"
import wardrobe from "../images/wodrop.jpeg"
import cabnet from "../images/cabnet.jpeg"
import design from "../images/design.png"
import weather from "../images/wehter.png"
import low from "../images/Low.webp"
import strong from "../images/strong.png"
import bug from "../images/bug.png"
import sound from "../images/sound.png"
import logo from "../images/logo.png"
import business from "../images/business.png"
import team from "../images/team.png"
import style from "../images/style.png"
import shade from "../images/shade.jpg"
import hylem from "../images/hylam.jpeg"
import facebook from "../images/facebook.png"
import instagram from "../images/Instagram.webp"
import linkedin from "../images/linkedin.png"
import x from "../images/x.png"

import * as React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { styled, useThemeProps } from '@mui/material/styles';




const StatRoot = styled('div', {
  name: 'MuiStat',
  slot: 'root',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  padding: theme.spacing(3, 4),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[2],
  letterSpacing: '-0.025em',
  fontWeight: 600,
  variants: [
    {
      props: {
        variant: 'outlined',
      },
      style: {
        border: `2px solid ${theme.palette.divider}`,
        boxShadow: 'none',
      },
    },
  ],
  ...theme.applyStyles('dark', {
    backgroundColor: 'inherit',
  }),
}));

const StatValue = styled('div', {
  name: 'MuiStat',
  slot: 'value',
})(({ theme }) => ({
  ...theme.typography.h3,
}));

const StatUnit = styled('div', {
  name: 'MuiStat',
  slot: 'unit',
})(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    color: 'inherit',
  }),
}));

const Stat = React.forwardRef(function Stat(inProps, ref) {
  const props = useThemeProps({ props: inProps, name: 'MuiStat' });
  const { value, unit, variant, ...other } = props;

  const ownerState = { ...props, variant };

  return (
    <StatRoot ref={ref} ownerState={ownerState} {...other}>
      <StatValue ownerState={ownerState}>{value}</StatValue>
      <StatUnit ownerState={ownerState}>{unit}</StatUnit>
    </StatRoot>
  );
});

Stat.propTypes = {
  unit: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  variant: PropTypes.oneOf(['outlined']),
};
function Home() {
  return (

    <main>

      <div className="p-4 p-md-5 mb-4 text-black rounded font-black"
        style={{
          backgroundImage: `url(${buildingImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "400px", objectFit: "cover"
        }}>
        <Stack direction="row">
          <Stat value="584+" unit="Projects" />
        </Stack><br />
        <Stack direction="row" >
          <Stat value="654565+" unit="Windows Installed" />
        </Stack><br />
        <span class="mb-1">
          <a className="rounded-circle" alt="Location" href="https://www.facebook.com/share/17gSdqkEiv/"><img src={facebook} style={{ height: "30px", width: "30px" }} /></a>&nbsp;
          <a className="rounded-circle" alt="Location" href="https://www.instagram.com/invites/contact/?igsh=1izl3bvvj2uj3&utm_content=zvshzkp"><img src={instagram} style={{ height: "30px", width: "30px" }} /></a>&nbsp;
          <a className="rounded-circle" alt="Location" href="https://www.linkedin.com/in/skyindoors-undefined-2866653a1"><img src={linkedin} style={{ height: "30px", width: "30px" }} /></a>&nbsp;
          <a className="rounded-circle" alt="Location" href="https://x.com/SkyIndoors"><img src={x} style={{ height: "30px", width: "30px" }} /></a>&nbsp;
        </span>
      </div>



      <hr class="featurette-divider" />
      
      <h1>OUR SERVICES</h1>
      <p className="lead my-3 text-black"><strong>
        We specialize in custom-made windows, Doors, Partitions, Wardrobes & Kitchen Cabinets — Expertly Crafted</strong>
      </p>
      <div class="container marketing">

        <div class="album py-5 bg-light">
          <div class="container">

            <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">

              <div class="col">
                <div class="card shadow-sm">
                  <a href="/windows"><img src={windoors} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }}
                  /></a>
                  <div class="card-body">
                    <p class="card-text">Crafting high-quality domal windows, two track, three track windows with precision and excellence.</p>
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="btn-group">
                        <a href="/windows" class="btn btn-sm btn-info">View Projects</a>
                      </div>
                      <small class="text-muted">Windows</small>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="card shadow-sm">
                  <a href="/doors"><img src={doors} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
                    </a>
                  <div class="card-body">
                    <p class="card-text">We are the best Aluminium openable and sliding door designs and high-quality products at the best rates.</p>
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="btn-group">
                        <a href="/doors" class="btn btn-sm btn-info">View Projects</a>
                      </div>
                      <small class="text-muted">Doors</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="card shadow-sm">
                  <a href="/wardrobe"><img src={wardrobe} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
                   </a>
                  <div class="card-body">
                    <p class="card-text">Delivering premium profile, domal, two track and three track wardrobe, crafted for durability and design.</p>
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="btn-group">
                        <a href="/wardrobe" class="btn btn-sm btn-info">View Projects</a>
                      </div>
                      <small class="text-muted">Wardrobe</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="card shadow-sm">
                  <a href="/cabnet"><img src={cabnet} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
                    </a>
                  <div class="card-body">
                    <p class="card-text">Your One-Stop Solution for Kitchen Cabnets</p>
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="btn-group">
                        <a href="/cabnet" class="btn btn-sm btn-info">View Projects</a>
                      </div>
                      <small class="text-muted">Kitchen Cabnets</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="card shadow-sm">
                  <a href="/elevation"><img src={elevation} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
                     </a>
                  <div class="card-body">
                    <p class="card-text">Shaping Modern Spaces with Elevation</p>
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="btn-group">
                        <a href="/elevation" class="btn btn-sm btn-info">View Projects</a>
                      </div>
                      <small class="text-muted">Elevation</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="card shadow-sm">
                  <a href="/partition"><img src={partation} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
                     </a>
                  <div class="card-body">
                    <p class="card-text">Built for Strength, Designed for Living</p>
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="btn-group">
                        <a href="/partition" class="btn btn-sm btn-info">View Projects</a>
                      </div>
                      <small class="text-muted">Partitions</small>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <hr class="featurette-divider" />
        <h1>Why Skyindoors</h1>
        <div class="row">
          <div class="col-lg-4">
            <img src={design} className="bd-placeholder-img rounded-circle" alt="Thumbnail" style={{ height: "140px", width: "140px" }} />

            <h2>Stunning Designs</h2>
            <p>Customers will be able to choose from a variety of designs, styles, and their very own individual preferences to have their dream home come to life.</p>
          </div>
          <div class="col-lg-4">
            <img src={weather} className="bd-placeholder-img rounded-circle" alt="Thumbnail" style={{ height: "140px", width: "140px" }} />

            <h2>Weather Resistant</h2>
            <p>The exterior is treated with a special coating that makes, resistant to atmospheric corrosion as well as discoloration from rainwater, polluted air and UV rays.</p>
          </div>
          <div class="col-lg-4">
            <img src={low} className="bd-placeholder-img rounded-circle" alt="Thumbnail" style={{ height: "140px", width: "140px" }} />

            <h2>Low Maintenance</h2>
            <p>Our windows are designed with minimal maintenance in mind. You'll be able to keep your home looking great without any extra hassle.</p>
          </div>
          <div class="col-lg-4">
            <img src={strong} className="bd-placeholder-img rounded-circle" alt="Thumbnail" style={{ height: "140px", width: "140px" }} />

            <h2>Durable and Strong</h2>
            <p>All our products are designed for maximum performance, guaranteeing that you'll never need to replace your window and doors again.</p>
          </div>
          <div class="col-lg-4">
            <img src={bug} className="bd-placeholder-img rounded-circle" alt="Thumbnail" style={{ height: "140px", width: "140px" }} />

            <h2>Bugs Free</h2>
            <p>Our windows are designed with a special sealant that keeps bugs and other pests out of your home. We also offer regular pest control for added peace of mind.</p>
          </div>
          <div class="col-lg-4">
            <img src={sound} className="bd-placeholder-img rounded-circle" alt="Thumbnail" style={{ height: "140px", width: "140px" }} />

            <h2>Sound Insulation</h2>
            <p>No more outside noise disrupting your mornings or nights. Our windows eliminate all sound coming in from outside so you can enjoy peaceful environment.</p>
          </div>


        </div>
        <hr class="featurette-divider" />
        <div
  id="carouselExampleIndicators"
  className="carousel slide"
  data-bs-ride="carousel"
  data-bs-interval="3000"
  data-bs-pause="false"
>

  {/* Indicators */}
  <div className="carousel-item active">
    <button
      type="button"
      data-bs-target="#carouselExampleIndicators"
      data-bs-slide-to="0"
      className="active"
      aria-current="true"
    ></button>
    <button
      type="button"
      data-bs-target="#carouselExampleIndicators"
      data-bs-slide-to="1"
    ></button>
    <button
      type="button"
      data-bs-target="#carouselExampleIndicators"
      data-bs-slide-to="2"
    ></button>
  </div>

  {/* Slides */}
  <div className="carousel-inner">

    <div className="carousel-item active text-center">
      <h2>Windoors Style – Reimagined</h2>
      <img
        src={style}
        className="d-block w-100 img-fluid rounded"
        alt="Windoors Style"
      />
    </div>

    <div className="carousel-item text-center">
      <h2>Perfect Shades</h2>
      <img
        src={shade}
        className="d-block w-100 img-fluid rounded"
        alt="Perfect Shades"
      />
    </div>

    <div className="carousel-item text-center">
      <h2>Hylam / ACP Sheets</h2>
      <img
        src={hylem}
        className="d-block w-100 img-fluid rounded"
        alt="Hylam ACP"
      />
    </div>

  </div>

  {/* Controls */}
  <button
    className="carousel-control-prev"
    type="button"
    data-bs-target="#carouselExampleIndicators"
    data-bs-slide="prev"
  >
    <span className="carousel-control-prev-icon"></span>
  </button>

  <button
    className="carousel-control-next"
    type="button"
    data-bs-target="#carouselExampleIndicators"
    data-bs-slide="next"
  >
    <span className="carousel-control-next-icon"></span>
  </button>
</div>
        <hr class="featurette-divider" />


        <h1>ABOUT US</h1>

        <div class="row">
          <div class="col-lg-4">
            <img src={logo} className="bd-placeholder-img rounded-circle" alt="Thumbnail" style={{ height: "140px", width: "140px" }} />

            <h2>Our Product</h2>
            <p>We use only premium materials and the highest quality workmanship to give you the best product possible.</p>
          </div>
          <div class="col-lg-4">
            <img src={business} className="bd-placeholder-img rounded-circle" alt="Thumbnail" style={{ height: "140px", width: "140px" }} />

            <h2>11+ Years in business</h2>
            <p> It is backed by our 10-year warranty, so you can be confident that your windows and doors will serve you for years to come.</p>
          </div>
          <div class="col-lg-4">
            <img src={team} className="bd-placeholder-img rounded-circle" alt="Thumbnail" style={{ height: "140px", width: "140px" }} />

            <h2>Our Team</h2>
            <p>Trained Installation team with proper tools for great performance, sustainability, sound insulation and security.</p>
            <p><a class="btn btn-info" href="/about">View details&raquo;</a></p>
          </div>
        </div>
        <hr class="featurette-divider" />


      </div>


    </main>
  );
}

export default Home;
